import { useCart } from '@/context/CartContext';

const logoUrl = '/img/logo.png';

const whatsappNumber = '55999260502';
const whatsappLink = `https://wa.me/${whatsappNumber}?text=Olá!%20Gostaria%20de%20conhecer%20os%20produtos%20da%20Maçã%20Verde.`;

function Footer() {
  const { setIsOpen } = useCart();

  return (
    <footer className="bg-primary-800 text-white">
      <div className="w-full px-4 md:px-6 lg:px-8 py-10 md:py-14">
        <div className="flex flex-col md:flex-row items-center md:items-start justify-between gap-8">
          {/* Brand */}
          <div className="text-center md:text-left">
            <div className="flex items-center gap-2 justify-center md:justify-start mb-3">
              <img src={logoUrl} alt="Maçã Verde" className="w-10 h-10 rounded-full object-cover" />
              <span className="font-heading text-xl font-semibold text-white">Maçã Verde</span>
            </div>
            <p className="text-sm text-white/70 max-w-xs">
              Moda infantil com conforto, qualidade e estilo.
            </p>
          </div>

          {/* Links */}
          <div className="flex flex-wrap items-center justify-center gap-6">
            <a href="#inicio" onClick={(e) => { e.preventDefault(); document.querySelector('#inicio')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-white/70 hover:text-white transition-colors">
              Início
            </a>
            <a href="#catalogo" onClick={(e) => { e.preventDefault(); document.querySelector('#catalogo')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-white/70 hover:text-white transition-colors">
              Catálogo
            </a>
            <a href="#sobre" onClick={(e) => { e.preventDefault(); document.querySelector('#sobre')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-white/70 hover:text-white transition-colors">
              Sobre
            </a>
            <a href="#contato" onClick={(e) => { e.preventDefault(); document.querySelector('#contato')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-white/70 hover:text-white transition-colors">
              Contato
            </a>
            <button type="button" onClick={() => setIsOpen(true)} className="text-sm text-white/70 hover:text-white transition-colors">
              Carrinho
            </button>
          </div>

          {/* Social */}
          <div className="flex items-center gap-3">
            <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-lg border border-white/30 hover:bg-white/10 transition-colors" aria-label="WhatsApp">
              <i className="ri-whatsapp-line text-lg" />
            </a>
            <a href="https://instagram.com/mundomacaverde" target="_blank" rel="noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-lg border border-white/30 hover:bg-white/10 transition-colors" aria-label="Instagram">
              <i className="ri-instagram-line text-lg" />
            </a>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-white/20 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-white/60">&copy; {new Date().getFullYear()} Maçã Verde. Todos os direitos reservados.</p>
          <p className="text-xs text-white/60">Desenvolvido por <span className="text-white/80">Camaleal Marketing Digital</span></p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;